import { useState } from "react";
import { useNavigate } from "react-router-dom";

import CampaignsTable from "containers/admin/clients/client/campaigns-page/components/campaigns-table/campaigns-table";
import { Breadcrumbs } from "ui/breadcrumbs";
import { FillHeightPage } from "ui/data-grid";
import { ActionsMenu, ActionsMenuButton, MenuItem, ActionMenuDivider } from "ui/actions-menu";
import { CreateCampaignFromTemplateModal } from "components/modals/create-campaign-from-template-modal/create-campaign-from-template-modal";
import { CreateCampaignWithWriterModal } from "components/modals/create-campaign-with-writer-modal/create-campaign-with-writer-modal";

import { useFeatureFlag } from "contexts/feature-flag-context";
import { usePermissionBlacklist } from "hooks/use-permission-blacklist";

import { useCurrentClient } from "hooks/api/use-clients";
import { getClientPaths } from "utilities/app-routes";

import { Permission } from "types/auth";

import Icons from "assets";

export const CampaignsPage = () => {
  const navigate = useNavigate();
  const currentClient = useCurrentClient();
  const paths = getClientPaths({ clientId: currentClient?.id });
  const [isNewCampaignDropdownOpen, setIsNewCampaignDropdownOpen] = useState(false);
  const [isCampaignFromTemplateModalOpen, setIsCampaignFromTemplateModalOpen] = useState(false);
  const [isCampaignWithWriterModalOpen, setIsCampaignWithWriterModalOpen] = useState(false);
  const isProgramBriefsEnabled = useFeatureFlag("program-briefs");

  const handleNewCampaignDropdownOpen = () => setIsNewCampaignDropdownOpen(true);
  const handleNewCampaignDropdownClose = () => setIsNewCampaignDropdownOpen(false);

  usePermissionBlacklist([Permission.PERM_CLIENT_USER]);

  const createButton = (
    <ActionsMenu
      itemName="new campaign"
      open={isNewCampaignDropdownOpen}
      onOpen={handleNewCampaignDropdownOpen}
      onClose={handleNewCampaignDropdownClose}
      menuId="new-campaign-menu"
      offsetLeft={2}
      offsetTop={10}
      trigger={<ActionsMenuButton size="large">Create</ActionsMenuButton>}>
      <MenuItem
        icon={<Icons.SidebarNavClient />}
        label="From Monday"
        onClick={() => setIsCampaignFromTemplateModalOpen(true)}
        data-testid="new-campaign-menu-from-template"
      />
      {isProgramBriefsEnabled && (
        <MenuItem
          icon={<Icons.HistoryEdu />}
          label="From brief"
          onClick={() => setIsCampaignWithWriterModalOpen(true)}
          data-testid="new-campaign-menu-with-writer"
        />
      )}
      <ActionMenuDivider />
      <MenuItem
        icon={<Icons.Edit />}
        label="Custom campaign"
        onClick={() => navigate("new")}
        data-testid="new-campaign-menu-custom"
      />
    </ActionsMenu>
  );

  return (
    <FillHeightPage>
      <Breadcrumbs
        breadcrumbs={[
          { label: currentClient?.name, href: paths.clientCampaignsPath },
          { label: "Campaigns", active: true },
        ]}
      />

      <CampaignsTable actionSlot={createButton} />

      {isCampaignFromTemplateModalOpen && (
        <CreateCampaignFromTemplateModal
          isOpen={isCampaignFromTemplateModalOpen}
          setIsOpen={setIsCampaignFromTemplateModalOpen}
        />
      )}

      {isProgramBriefsEnabled && isCampaignWithWriterModalOpen && (
        <CreateCampaignWithWriterModal
          isOpen={isCampaignWithWriterModalOpen}
          setIsOpen={setIsCampaignWithWriterModalOpen}
        />
      )}
    </FillHeightPage>
  );
};
